/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import firebase from "firebase/compat/app";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { db } from "../config/firebaseConfig";
import { UserAuth } from "../context/authContext";
import CreateTranscation from "./CreateTranscation";
import CopyComponent from "./utils/CopyComponent";
import PrismCard from "./PrismCard";
const CreateTransaction = () => {
  const { userData, user } = UserAuth();
  const [roomId, setRoomId] = useState(localStorage.getItem("roomId") || "");
  const [datax, setDatax] = useState("");

  useEffect(() => {
    if (!roomId) return;

    const unsubscribe=db
      .collection("rooms")
      .doc(roomId)
      .onSnapshot(
        (roomSnapshot) => {
          if (roomSnapshot.exists) {
            const data=roomSnapshot.data();
            setDatax(data);
            setCreatedBy(data.createdBy||[]);
          } else {
            localStorage.removeItem("roomId");
            window.location.reload();
          }
        },
        (error) => {
          console.error("Error fetching room details:", error);
          toast.error("Error fetching room details.");
        },
      );

    return () => unsubscribe();
  }, [roomId]);

  const [role, setRole]=useState(() => localStorage.getItem("role")||"");
  const [createdBy, setCreatedBy]=useState([]);

  const handleLeaveRoom=async () => {
    try {
      await db
        .collection("rooms")
        .doc(roomId)
        .update({
          [`${role}s`]: firebase.firestore.FieldValue.arrayRemove(
            userData.publicKey,
          ),
        });
      localStorage.removeItem("roomId");
      localStorage.removeItem("role");
      toast.success("You have left the room successfully.");
      window.location.href="/";
      setRoomId("");
      setRole("");
    } catch (error) {
      console.error("Error leaving room:", error);
      toast.error("Failed to leave room. Please try again later.");
    }
  };

  const handleEndRoom=async () => {
    if (roomId&&user.email) {
      try {
        const roomDocRef=db.collection("rooms").doc(roomId);

        const subcollectionNames=["blocks", "transactions"];

        await Promise.all(
          subcollectionNames.map(async (subcollectionName) => {
            const subcollectionRef=roomDocRef.collection(subcollectionName);
            const docs=await subcollectionRef.get();
            docs.forEach(async (doc) => {
              await doc.ref.delete();
            });
          }),
        );

        await roomDocRef.delete();

        toast.success("Room ended successfully.");
        ///dashbaord
        window.location.href="/";

        // Reset local state and UI as necessary
        setRoomId("");
        localStorage.removeItem("roomId"); // Clear stored roomId if using localStorage
      } catch (error) {
        console.error("Error ending room:", error);
        toast.error("Failed to end room. Please try again later.");
      }
    } else {
      toast.error("Cannot end room: Room ID or user information is missing.");
    }
  };

  return (
    <section className="min-h-screen pt-10 pb-8 px-6">
      <div className="max-w-7xl mx-auto text-white">
        <h1 className="text-2xl font-bold text-white mb-6">
          Create Transaction
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Left Card - Room Info */}
          <PrismCard className="bg-white/5 backdrop-blur-xl rounded-xl p-8 border border-white/10 shadow-2xl shadow-purple-500/10 before:absolute before:inset-0 before:rounded-xl before:bg-gradient-to-br before:from-white/10 before:to-transparent before:opacity-50 before:pointer-events-none">
            <div className="flex items-center gap-3 mb-6 relative z-10">
              <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="text-purple-400"
                >
                  <circle cx="12" cy="12" r="1"/>
                  <path d="M12 1v6m0 6v4"/>
                  <path d="M4.22 4.22l4.24 4.24m5.08 5.08l4.24 4.24"/>
                  <path d="M1 12h6m6 0h4"/>
                  <path d="M4.22 19.78l4.24-4.24m5.08-5.08l4.24-4.24"/>
                  <path d="M12 23v-6m0-6v-4"/>
                  <path d="M19.78 19.78l-4.24-4.24m-5.08-5.08l-4.24-4.24"/>
                  <path d="M23 12h-6m-6 0h-4"/>
                  <path d="M19.78 4.22l-4.24 4.24m-5.08 5.08l-4.24 4.24"/>
                </svg>
              </div>
              <span className="text-white font-semibold">
                Balance: {userData?.balance?.toFixed(2) || "0.00"}
              </span>
            </div>

            <div className="space-y-4 relative z-10">
              <div>
                <label className="text-white/60 text-sm mb-2 block">
                  Room Id
                </label>
                <div className="flex items-center gap-2 bg-[#1B1E3E]/60 border border-white/10 rounded-lg px-4 py-3">
                  <input
                    type="text"
                    readOnly
                    className="flex-1 bg-transparent text-white text-sm outline-none truncate"
                    value={roomId||""}
                  />
                  <button
                    onClick={() => {
                      if (roomId&&navigator.clipboard) {
                        navigator.clipboard.writeText(roomId);
                        toast.success("Room ID copied!");
                      }
                    }}
                    className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <rect
                        x="9"
                        y="9"
                        width="13"
                        height="13"
                        rx="2"
                        stroke="white"
                        strokeWidth="2"
                        fill="none"
                      />
                      <path
                        d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                        stroke="white"
                        strokeWidth="2"
                        fill="none"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <div>
                <label className="text-white/60 text-sm mb-2 block">
                  Public Id
                </label>
                <div className="flex items-center gap-2 bg-[#1B1E3E]/60 border border-white/10 rounded-lg px-4 py-3">
                  <input
                    type="text"
                    readOnly
                    className="flex-1 bg-transparent text-white text-sm outline-none truncate"
                    value={userData?.publicKey||""}
                  />
                  <button
                    onClick={() => {
                      if (userData?.publicKey&&navigator.clipboard) {
                        navigator.clipboard.writeText(userData.publicKey);
                        toast.success("Public key copied!");
                      }
                    }}
                    className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <rect
                        x="9"
                        y="9"
                        width="13"
                        height="13"
                        rx="2"
                        stroke="white"
                        strokeWidth="2"
                        fill="none"
                      />
                      <path
                        d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                        stroke="white"
                        strokeWidth="2"
                        fill="none"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <div>
                <label className="text-white/60 text-sm mb-2 block">
                  Private Id
                </label>
                <div className="flex items-center gap-2 bg-[#1B1E3E]/60 border border-white/10 rounded-lg px-4 py-3">
                  <input
                    type="password"
                    readOnly
                    className="flex-1 bg-transparent text-white text-sm outline-none"
                    value={userData?.privateKey||""}
                  />
                  <button
                    onClick={() => {
                      if (userData?.privateKey&&navigator.clipboard) {
                        navigator.clipboard.writeText(userData.privateKey);
                        toast.success("Private key copied!");
                      }
                    }}
                    className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <rect
                        x="9"
                        y="9"
                        width="13"
                        height="13"
                        rx="2"
                        stroke="white"
                        strokeWidth="2"
                        fill="none"
                      />
                      <path
                        d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                        stroke="white"
                        strokeWidth="2"
                        fill="none"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div className="mt-6 relative z-10">
              {createdBy === user.email ? (
                <button
                  onClick={handleEndRoom}
                  type="button"
                  className="w-full px-6 py-3 bg-gradient-to-r from-[#6C4FFF] to-[#5B3FE8] hover:from-[#5B3FE8] hover:to-[#4A2FD7] rounded-lg font-semibold text-white transition-all"
                >
                  End room
                </button>
              ):(
                <button
                  onClick={handleLeaveRoom}
                  type="button"
                  className="w-full px-6 py-3 bg-gradient-to-r from-[#6C4FFF] to-[#5B3FE8] hover:from-[#5B3FE8] hover:to-[#4A2FD7] rounded-lg font-semibold text-white transition-all"
                >
                  Leave Room
                </button>
              )}
            </div>
          </PrismCard>

          {/* Right Card - Create Transaction */}
          <PrismCard className="bg-white/5 backdrop-blur-xl rounded-xl p-8 border border-white/10 shadow-2xl shadow-purple-500/10 before:absolute before:inset-0 before:rounded-xl before:bg-gradient-to-br before:from-white/10 before:to-transparent before:opacity-50 before:pointer-events-none">
            <div className="flex items-center gap-3 mb-6 relative z-10">
              <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="text-green-400"
                >
                  <path d="M12 5v14M5 12h14"/>
                </svg>
              </div>
              <span className="text-white font-semibold">
                Create Transaction
              </span>
            </div>

            <div className="relative z-10">
              <CreateTranscation
                user={user}
                userData={userData}
                roomId={roomId}
              />
            </div>
          </PrismCard>
        </div>
        <div className="row">
          <div className="w-[40rem]">
            <ListofParticipant roomId={roomId} />
            <ListMiner roomId={roomId} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreateTransaction;
const ListofParticipant=({ roomId }) => {
  const [participants, setParticipants]=useState([]);

  useEffect(() => {
    if (!roomId) return;

    const unsubscribe=db
      .collection("rooms")
      .doc(roomId)
      .onSnapshot(async (doc) => {
        if (doc.exists) {
          const roomData=doc.data();
          if (roomData.participants&&roomData.participants.length>0) {
            const users=await getDocs(
              query(
                collection(db, "users"),
                where("publicKey", "in", roomData.participants),
              ),
            );
            setParticipants(users.docs.map((v) => v.data()));
          } else {
            setParticipants([]);
          }
        }
      });

    return () => unsubscribe();
  }, [roomId]);

  return (
    <div className="bg-[#343B4F]/60 backdrop-blur mt-4 rounded-xl p-5 border border-white/10">
      <h4 className="text-white/80 text-base font-normal mb-4">
        List of Participants
      </h4>
      <div className="space-y-3">
        {participants.length===0? (
          <p className="text-white/40 text-sm">No participants</p>
        ):(
          participants.map((participant, index) => (
            <div key={index} className="flex items-start gap-2">
              <div className="flex-1 min-w-0 ">
                <div className="flex items-center gap-2 mb-1 cursor-pointer">
                  <span className="text-white  px-2 py-1 rounded text-xs font-mono">
                    {participant.email}
                  </span>
                  <CopyComponent data={participant.publicKey} />
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

const ListMiner=({ roomId }) => {
  const [miners, setMiners]=useState([]);

  useEffect(() => {
    if (!roomId) return;

    const unsubscribe=db
      .collection("rooms")
      .doc(roomId)
      .onSnapshot(async (doc) => {
        if (doc.exists) {
          const roomData=doc.data();

          if (roomData.miners&&roomData.miners.length>0) {
            const users=await getDocs(
              query(
                collection(db, "users"),
                where("publicKey", "in", roomData.miners),
              ),
            );

            setMiners(users.docs.map((v) => v.data()));
          } else {
            setMiners([]);
          }
        }
      });

    return () => unsubscribe();
  }, [roomId]);

  return (
    <div className="bg-[#343B4F]/60 backdrop-blur rounded-xl p-5 border border-white/10 mt-4">
      <h4 className="text-white/80 text-base font-normal mb-4">
        List of Miners
      </h4>
      <div className="space-y-3">
        {miners.length===0? (
          <p className="text-white/40 text-sm">No miners</p>
        ):(
          miners.map((participant, index) => (
            <div key={index} className="flex items-start gap-2">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 cursor-pointer">
                  <span className="text-white  px-2 py-1 rounded text-xs font-mono">
                    {participant.email}
                  </span>
                  <CopyComponent data={participant.publicKey} />
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
